import React from "react";
import { useTranslation } from "react-i18next";
import Button from "src/components/Button";
import useTaskForm from "src/hooks/api/tasks/useTaskForm";

const SaveTaskButton = () => {
	const { t } = useTranslation("buttons");

	const { actions, status } = useTaskForm();
	return (
		<Button
			loading={status === "updating"}
			onClick={() => {
				actions.save();
			}}
		>
			{t("save")}
		</Button>
	);
};

export default SaveTaskButton;
